{
    "PreviewHeader": "Anteprima",
    "PreviewValueInvalid": "[Formato non valido]",
    "NAME": "Preview"
}